'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _intlProviderWrapper = require('./intl-provider-wrapper');

var _intlProviderWrapper2 = _interopRequireDefault(_intlProviderWrapper);

var _recommendationItem = require('../../src/styles/recommendation-item.scss');

var _recommendationItem2 = _interopRequireDefault(_recommendationItem);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RecommendationItem = function RecommendationItem(props) {
    var styles = props.classNames ? (0, _extends3.default)({}, _recommendationItem2.default, props.classNames) : _recommendationItem2.default;
    var wrapperClassName = styles['recommendation-item'] + ' ' + (props.additionalClass ? " " + props.additionalClass : " ");
    var wrapperStyle = props.wrapperStyle;

    var contentTextHeight = props.contentStyle.height.slice(0, -2) - 28 + 'px';
    return _react2.default.createElement(
        'div',
        {
            className: [wrapperClassName, props.showFrame && _recommendationItem2.default["recommendation-item_frame"]].join(" "),
            style: wrapperStyle
        },
        _react2.default.createElement(
            'div',
            { className: styles["recommendation-item__header"] },
            _react2.default.createElement(
                'a',
                { href: 'https://www.doctify.com/uk/specialist/' + props.recommendee.uri_id,
                    className: styles["recommendation-item__image"],
                    target: "_blank",
                    rel: "nofollow noopener"
                },
                _react2.default.createElement('img', { src: props.recommendee.image, alt: props.recommendee.name })
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: styles["recommendation-item__recommendee"] },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'RecommendationItem.recommending'
                    }),
                    _react2.default.createElement(
                        'div',
                        { className: _style2.default["text-bold"] },
                        props.recommendee.name
                    )
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { style: props.contentStyle, className: styles["recommendation-item__content"] },
            _react2.default.createElement(
                'div',
                { style: { maxHeight: contentTextHeight } },
                props.content
            )
        ),
        _react2.default.createElement(
            'a',
            {
                href: 'https://www.doctify.com/uk/specialist/' + props.recommender.uri_id,
                className: styles["recommendation-item__recommender"],
                target: '_blank',
                rel: 'nofollow noopener'
            },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'RecommendationItem.by'
            }),
            '\xA0',
            props.recommender.name,
            _react2.default.createElement(
                'div',
                { className: styles["recommendation-item__recommender-image"] },
                _react2.default.createElement('img', { src: props.recommender.image, alt: props.recommender.name })
            )
        ),
        _react2.default.createElement(
            'div',
            { className: (props.speciality || props.connection) && _style2.default["mb-3"] },
            props.speciality && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'span',
                    { className: [_style2.default["text-bold"], _style2.default["mr-4"]].join(" ") },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'RecommendationItem.for_specialty'
                    }),
                    ':'
                ),
                props.speciality
            ),
            props.connection && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'span',
                    { className: [_style2.default["text-bold"], _style2.default["mr-4"]].join(" ") },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'RecommendationItem.connection'
                    }),
                    ':'
                ),
                props.connection
            )
        ),
        _react2.default.createElement(
            'div',
            null,
            props.date
        )
    );
};

RecommendationItem.propTypes = {
    recommendee: _propTypes2.default.shape({
        name: _propTypes2.default.string.isRequired,
        image: _propTypes2.default.string.isRequired,
        uri_id: _propTypes2.default.string.isRequired
    }),
    recommender: _propTypes2.default.shape({
        name: _propTypes2.default.string.isRequired
    }),
    content: _propTypes2.default.string.isRequired,
    speciality: _propTypes2.default.string,
    connection: _propTypes2.default.string,
    contentStyle: _propTypes2.default.object,
    wrapperStyle: _propTypes2.default.object,
    showFrame: _propTypes2.default.bool
};

RecommendationItem.defaultProps = {
    contentStyle: {},
    wrapperStyle: {}
};

exports.default = (0, _intlProviderWrapper2.default)(RecommendationItem);
